export const contractMenus = [
    {
        title: '合同管理', key: 'comp_info', icon: 'icon iconfont icon-sssss', compTypes: [1, 2, 3, 4], children: [
            { title: '印章管理', key: '/contract/stamp', icon: 'icon iconfont icon-lujing19', privi: 1005 },
            { title: '经办合同', key: '/contract/contract', icon: 'icon iconfont icon-zu41', privi: 1004 },
        ]
    }
];